


















































































































































import { Component, Vue } from "vue-property-decorator";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import AsesmenGadarKeperawatanStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarKeperawatanStore";
import AsesmenSurveyPrimerGadarStore from "@/store/modules/AsesmenAwalGadar/AsesmenSurveyPrimerGadarStore";

@Component
export default class PreviewAsesmenPerawatGadarNew extends Vue {
  get register() {
    return RegisterKunjungan.register["no"];
  }

  get storeAsesmenPerawat() {
    return AsesmenGadarKeperawatanStore;
  }

  get storeSurveyPrimer() {
    return AsesmenSurveyPrimerGadarStore.asesmen;
  }

  get riwayatObstetri() {
    return (
      this.storeAsesmenPerawat.asesmen?.content.riwayatObstetri ?? {
        riwayat: "-",
        g: "-",
        p: "-",
        a: "-",
        hpht: "-",
        hpl: "-",
        palpasi: "-",
        tfu: "-",
        tbj: "-",
        his: "-",
        djj: "-",
        panggul: "-",
        vt: "-",
        lla: "-",
        tb: "-",
        bb: "-",
        kb: "-",
        kbDescription: "-"
      }
    );
  }

  get riwayatKb() {
    const obs = this.storeAsesmenPerawat.asesmen?.content?.riwayatObstetri;

    // `kbJenis` = isian "Riwayat Pemakaian KB" sekarang; `kb.name` hanya
    // cadangan untuk asesmen lama yang masih memakai status KB kategorikal.
    return obs?.kbJenis ?? obs?.kb?.name;
  }

  get riwayatKesehatan() {
    return this.storeAsesmenPerawat?.asesmen?.content.riwayatKesehatan
      ? this.storeAsesmenPerawat.asesmen.content.riwayatKesehatan
      : {
          alergi: "-",
          obat: "-",
          penyakitLalu: "-",
          makanTerakhir: "-",
          lain: "-"
        };
  }

  get tensiText() {
    if (this.tandaVital?.tensi) {
      const { sistole, diastole } = this.tandaVital.tensi;

      return sistole + (sistole && diastole ? "/" : "") + diastole;
    } else {
      return "-";
    }
  }

  get tandaVital() {
    return this.storeSurveyPrimer
      ? this.storeSurveyPrimer.content.tanda_vital
      : {
          tensi: null,
          nadi: "-",
          nafas: "-",
          suhu: "-",
          saturasi: "-"
        };
  }

  get gcs() {
    return this.storeSurveyPrimer
      ? {
          eye: this.storeSurveyPrimer.content?.gcs.eye,
          verbal: this.storeSurveyPrimer.content?.gcs.verbal,
          motor: this.storeSurveyPrimer.content?.gcs.motor
        }
      : {
          eye: "-",
          verbal: "-",
          motor: "-"
        };
  }

  async refreshIsianKeperawatan() {
    await AsesmenSurveyPrimerGadarStore.getByRegister(this.register);
    await AsesmenGadarKeperawatanStore.getByRegister(this.register);
  }
}
